"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.17.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupTestToJSON = exports.GroupTestFromJSONTyped = exports.GroupTestFromJSON = exports.instanceOfGroupTest = void 0;
var runtime_1 = require("../runtime");
var CommercialTestCategory_1 = require("./CommercialTestCategory");
var HelperBaseConcept_1 = require("./HelperBaseConcept");
var Reference_1 = require("./Reference");
var SearchGroup_1 = require("./SearchGroup");
/**
 * Check if a given object implements the GroupTest interface.
 */
function instanceOfGroupTest(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfGroupTest = instanceOfGroupTest;
function GroupTestFromJSON(json) {
    return GroupTestFromJSONTyped(json, false);
}
exports.GroupTestFromJSON = GroupTestFromJSON;
function GroupTestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'additionalAnalysis': !(0, runtime_1.exists)(json, 'additionalAnalysis') ? undefined : json['additionalAnalysis'],
        'aggregationType': !(0, runtime_1.exists)(json, 'aggregationType') ? undefined : json['aggregationType'],
        'alias': !(0, runtime_1.exists)(json, 'alias') ? undefined : json['alias'],
        'alternateSpecimens': !(0, runtime_1.exists)(json, 'alternateSpecimens') ? undefined : json['alternateSpecimens'],
        'alternativeTests': !(0, runtime_1.exists)(json, 'alternativeTests') ? undefined : json['alternativeTests'],
        'assayNoteParagraph': !(0, runtime_1.exists)(json, 'assayNoteParagraph') ? undefined : json['assayNoteParagraph'],
        'assayNotes': !(0, runtime_1.exists)(json, 'assayNotes') ? undefined : json['assayNotes'],
        'billing': !(0, runtime_1.exists)(json, 'billing') ? undefined : json['billing'],
        'cancerRisks': !(0, runtime_1.exists)(json, 'cancerRisks') ? undefined : json['cancerRisks'],
        'categories': !(0, runtime_1.exists)(json, 'categories') ? undefined : (json['categories'].map(CommercialTestCategory_1.CommercialTestCategoryFromJSON)),
        'changeCounter': !(0, runtime_1.exists)(json, 'changeCounter') ? undefined : json['changeCounter'],
        'changeDescription': !(0, runtime_1.exists)(json, 'changeDescription') ? undefined : json['changeDescription'],
        'clinicNotes': !(0, runtime_1.exists)(json, 'clinicNotes') ? undefined : json['clinicNotes'],
        'clinicalDescription': !(0, runtime_1.exists)(json, 'clinicalDescription') ? undefined : json['clinicalDescription'],
        'code': !(0, runtime_1.exists)(json, 'code') ? undefined : json['code'],
        'conceptType': !(0, runtime_1.exists)(json, 'conceptType') ? undefined : json['conceptType'],
        'criteriaType': !(0, runtime_1.exists)(json, 'criteriaType') ? undefined : json['criteriaType'],
        'dateReviewed': !(0, runtime_1.exists)(json, 'dateReviewed') ? undefined : json['dateReviewed'],
        'deldupAnalysis': !(0, runtime_1.exists)(json, 'deldupAnalysis') ? undefined : json['deldupAnalysis'],
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
        'disorderInformation': !(0, runtime_1.exists)(json, 'disorderInformation') ? undefined : json['disorderInformation'],
        'disordersTested': !(0, runtime_1.exists)(json, 'disordersTested') ? undefined : json['disordersTested'],
        'displayName': !(0, runtime_1.exists)(json, 'displayName') ? undefined : json['displayName'],
        'externalUrl': !(0, runtime_1.exists)(json, 'externalUrl') ? undefined : json['externalUrl'],
        'geneAssociatedDisorders': !(0, runtime_1.exists)(json, 'geneAssociatedDisorders') ? undefined : json['geneAssociatedDisorders'],
        'geneFunction': !(0, runtime_1.exists)(json, 'geneFunction') ? undefined : json['geneFunction'],
        'geneLocation': !(0, runtime_1.exists)(json, 'geneLocation') ? undefined : json['geneLocation'],
        'geneTests': !(0, runtime_1.exists)(json, 'geneTests') ? undefined : (json['geneTests'].map(HelperBaseConcept_1.HelperBaseConceptFromJSON)),
        'genesTargeted': !(0, runtime_1.exists)(json, 'genesTargeted') ? undefined : json['genesTargeted'],
        'indications': !(0, runtime_1.exists)(json, 'indications') ? undefined : json['indications'],
        'individualsTested': !(0, runtime_1.exists)(json, 'individualsTested') ? undefined : json['individualsTested'],
        'inheritance': !(0, runtime_1.exists)(json, 'inheritance') ? undefined : json['inheritance'],
        'inheritanceParagraph': !(0, runtime_1.exists)(json, 'inheritanceParagraph') ? undefined : json['inheritanceParagraph'],
        'limitations': !(0, runtime_1.exists)(json, 'limitations') ? undefined : json['limitations'],
        'locusName': !(0, runtime_1.exists)(json, 'locusName') ? undefined : json['locusName'],
        'management': !(0, runtime_1.exists)(json, 'management') ? undefined : json['management'],
        'mapperVersion': !(0, runtime_1.exists)(json, 'mapperVersion') ? undefined : json['mapperVersion'],
        'metaDescription': !(0, runtime_1.exists)(json, 'metaDescription') ? undefined : json['metaDescription'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'notes': !(0, runtime_1.exists)(json, 'notes') ? undefined : json['notes'],
        'ontology': !(0, runtime_1.exists)(json, 'ontology') ? undefined : json['ontology'],
        'order': !(0, runtime_1.exists)(json, 'order') ? undefined : json['order'],
        'parentName': !(0, runtime_1.exists)(json, 'parentName') ? undefined : json['parentName'],
        'penetrance': !(0, runtime_1.exists)(json, 'penetrance') ? undefined : json['penetrance'],
        'pmid': !(0, runtime_1.exists)(json, 'pmid') ? undefined : json['pmid'],
        'preferredSpecimen': !(0, runtime_1.exists)(json, 'preferredSpecimen') ? undefined : json['preferredSpecimen'],
        'prevalance': !(0, runtime_1.exists)(json, 'prevalance') ? undefined : json['prevalance'],
        'price': !(0, runtime_1.exists)(json, 'price') ? undefined : json['price'],
        'productType': !(0, runtime_1.exists)(json, 'productType') ? undefined : json['productType'],
        'productionStatus': !(0, runtime_1.exists)(json, 'productionStatus') ? undefined : json['productionStatus'],
        'reasonsForTesting': !(0, runtime_1.exists)(json, 'reasonsForTesting') ? undefined : json['reasonsForTesting'],
        'referenceName': !(0, runtime_1.exists)(json, 'referenceName') ? undefined : json['referenceName'],
        'references': !(0, runtime_1.exists)(json, 'references') ? undefined : (json['references'].map(Reference_1.ReferenceFromJSON)),
        'searchGroups': !(0, runtime_1.exists)(json, 'searchGroups') ? undefined : (json['searchGroups'].map(SearchGroup_1.SearchGroupFromJSON)),
        'sequencingAnalysis': !(0, runtime_1.exists)(json, 'sequencingAnalysis') ? undefined : json['sequencingAnalysis'],
        'sortOrder': !(0, runtime_1.exists)(json, 'sortOrder') ? undefined : json['sortOrder'],
        'subtypes': !(0, runtime_1.exists)(json, 'subtypes') ? undefined : json['subtypes'],
        'tags': !(0, runtime_1.exists)(json, 'tags') ? undefined : json['tags'],
        'testBenefits': !(0, runtime_1.exists)(json, 'testBenefits') ? undefined : json['testBenefits'],
        'testSensitivity': !(0, runtime_1.exists)(json, 'testSensitivity') ? undefined : json['testSensitivity'],
        'transcriptReference': !(0, runtime_1.exists)(json, 'transcriptReference') ? undefined : json['transcriptReference'],
        'turaroundTime': !(0, runtime_1.exists)(json, 'turaroundTime') ? undefined : json['turaroundTime'],
        'url': !(0, runtime_1.exists)(json, 'url') ? undefined : json['url'],
    };
}
exports.GroupTestFromJSONTyped = GroupTestFromJSONTyped;
function GroupTestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'additionalAnalysis': value.additionalAnalysis,
        'aggregationType': value.aggregationType,
        'alias': value.alias,
        'alternateSpecimens': value.alternateSpecimens,
        'alternativeTests': value.alternativeTests,
        'assayNoteParagraph': value.assayNoteParagraph,
        'assayNotes': value.assayNotes,
        'billing': value.billing,
        'cancerRisks': value.cancerRisks,
        'categories': value.categories === undefined ? undefined : (value.categories.map(CommercialTestCategory_1.CommercialTestCategoryToJSON)),
        'changeCounter': value.changeCounter,
        'changeDescription': value.changeDescription,
        'clinicNotes': value.clinicNotes,
        'clinicalDescription': value.clinicalDescription,
        'code': value.code,
        'conceptType': value.conceptType,
        'criteriaType': value.criteriaType,
        'dateReviewed': value.dateReviewed,
        'deldupAnalysis': value.deldupAnalysis,
        'description': value.description,
        'disorderInformation': value.disorderInformation,
        'disordersTested': value.disordersTested,
        'displayName': value.displayName,
        'externalUrl': value.externalUrl,
        'geneAssociatedDisorders': value.geneAssociatedDisorders,
        'geneFunction': value.geneFunction,
        'geneLocation': value.geneLocation,
        'geneTests': value.geneTests === undefined ? undefined : (value.geneTests.map(HelperBaseConcept_1.HelperBaseConceptToJSON)),
        'genesTargeted': value.genesTargeted,
        'indications': value.indications,
        'individualsTested': value.individualsTested,
        'inheritance': value.inheritance,
        'inheritanceParagraph': value.inheritanceParagraph,
        'limitations': value.limitations,
        'locusName': value.locusName,
        'management': value.management,
        'mapperVersion': value.mapperVersion,
        'metaDescription': value.metaDescription,
        'name': value.name,
        'notes': value.notes,
        'ontology': value.ontology,
        'order': value.order,
        'parentName': value.parentName,
        'penetrance': value.penetrance,
        'pmid': value.pmid,
        'preferredSpecimen': value.preferredSpecimen,
        'prevalance': value.prevalance,
        'price': value.price,
        'productType': value.productType,
        'productionStatus': value.productionStatus,
        'reasonsForTesting': value.reasonsForTesting,
        'referenceName': value.referenceName,
        'references': value.references === undefined ? undefined : (value.references.map(Reference_1.ReferenceToJSON)),
        'searchGroups': value.searchGroups === undefined ? undefined : (value.searchGroups.map(SearchGroup_1.SearchGroupToJSON)),
        'sequencingAnalysis': value.sequencingAnalysis,
        'sortOrder': value.sortOrder,
        'subtypes': value.subtypes,
        'tags': value.tags,
        'testBenefits': value.testBenefits,
        'testSensitivity': value.testSensitivity,
        'transcriptReference': value.transcriptReference,
        'turaroundTime': value.turaroundTime,
        'url': value.url,
    };
}
exports.GroupTestToJSON = GroupTestToJSON;
